module.exports = __webpack_public_path__ + "static/media/Places-12.100bf64d.jpg";